import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { navigate } from '../../utils/navigation';
import Drawer from '../Common/Drawer';
import { APP_VERSION } from '../../version';
import { isMemberUnpaidOrExpired } from '../../firebase';

interface SharedAppMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SharedAppMenu: React.FC<SharedAppMenuProps> = ({ isOpen, onClose }) => {
  const { user, profile, logOut, canAccessAdmin } = useAuth();
  const isRestricted = isMemberUnpaidOrExpired(profile);

  const handleLogout = async () => {
    try {
      await logOut();
    } catch (e) {
      console.error('[SharedAppMenu] Logout error:', e);
    } finally {
      onClose();
      navigate('/');
      window.location.reload();
    }
  };

  return (
    <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <div className="menu-drawer-content" onClick={(e) => e.stopPropagation()}>
        <div className="drawer-header">
          <img className="drawer-logo" src="/Images/logo.png" alt="Atl Card Sharks Logo" />
          <button className="drawer-close-btn" onClick={onClose} aria-label="Close menu">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        <div className="drawer-links">
          {user ? (
            <>
              {!isRestricted && (
                <>
                  <NavLink to="/directory" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                    <i className="bi bi-person-lines-fill"></i>
                    <span>Member Directory</span>
                  </NavLink>
                  <NavLink to="/leaderboard" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                    <i className="bi bi-trophy-fill"></i>
                    <span>Leaderboard</span>
                  </NavLink>
                  <NavLink to="/achievements" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                    <i className="bi bi-award-fill"></i>
                    <span>Achievements</span>
                  </NavLink>
                  <NavLink to="/gallery" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                    <i className="bi bi-images"></i>
                    <span>Gallery</span>
                  </NavLink>
                  <NavLink to="/history" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                    <i className="bi bi-clock-history"></i>
                    <span>Our History</span>
                  </NavLink>
                  <NavLink to="/arena" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                    <i className="bi bi-controller"></i>
                    <span>Bid Whist Arena</span>
                  </NavLink>
                </>
              )}
              {canAccessAdmin && (
                <NavLink to="/admin" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                  <i className="bi bi-shield-lock-fill"></i>
                  <span>Administration</span>
                </NavLink>
              )}
              {!isRestricted && (
                <NavLink to="/settings" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                  <i className="bi bi-gear-fill"></i>
                  <span>Settings</span>
                </NavLink>
              )}
              <button className="drawer-logout-btn" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right"></i>
                <span>Logout</span>
              </button>
            </>
          ) : (
            <>
              <NavLink to="/login" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                <i className="bi bi-box-arrow-in-right"></i>
                <span>Join or Login</span>
              </NavLink>
              <NavLink to="/leaderboard" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                <i className="bi bi-trophy-fill"></i>
                <span>Leaderboard</span>
              </NavLink>
              <NavLink to="/gallery" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                <i className="bi bi-images"></i>
                <span>Gallery</span>
              </NavLink>
              <NavLink to="/history" onClick={onClose} className={({ isActive }) => `drawer-link-item ${isActive ? 'active' : ''}`}>
                <i className="bi bi-clock-history"></i>
                <span>Our History</span>
              </NavLink>
            </>
          )}
        </div>

        <div className="drawer-footer mt-auto pt-8">
          <div className="nav-version">
            {APP_VERSION}
          </div>
        </div>
      </div>
    </Drawer>
  );
};
